import React, { useState, useRef } from 'react';
import t from 'prop-types';
var ORDEN_POR_FECHA = 'ORDEN_POR_FECHA';
var ORDEN_ALFABETICO = 'ORDEN_ALFABETICO';

function SelectorSesion(_ref) {
  var idUltimaSesionActiva = _ref.idUltimaSesionActiva,
      sesiones = _ref.sesiones,
      textoSesiones = _ref.textoSesiones,
      textoOrdenarPorFecha = _ref.textoOrdenarPorFecha,
      textoOrdenarAlfabeticamente = _ref.textoOrdenarAlfabeticamente,
      onSeleccionarSesion = _ref.onSeleccionarSesion,
      sesionSeleccionada = _ref.sesionSeleccionada,
      textoNuevaSesion = _ref.textoNuevaSesion,
      textoAceptar = _ref.textoAceptar,
      onNuevaSesion = _ref.onNuevaSesion,
      nuevoDisenoSesiones = _ref.nuevoDisenoSesiones;
  var nuevaSesionRef = useRef();

  var _useState = useState(ORDEN_POR_FECHA),
      orden = _useState[0],
      setOrden = _useState[1];

  var _useState2 = useState(idUltimaSesionActiva),
      idSesionSeleccionada = _useState2[0],
      setIdSesionSeleccionada = _useState2[1];

  function handleOrdenar(e) {
    setOrden(e.target.value);
  }

  function handleSeleccionarSesion(sesion) {
    setIdSesionSeleccionada(sesion.id);
    onSeleccionarSesion && onSeleccionarSesion(sesion);
  }

  function handleNuevaSesion() {
    var nombreSesion = nuevaSesionRef.current.value.trim();

    if (nombreSesion === "") {
      return;
    }

    nuevaSesionRef.current.value = "";
    var sesion = sesiones.find(function (sesion) {
      return sesion.nombre === nombreSesion;
    });

    if (!sesion) {
      onNuevaSesion(nombreSesion);
    } else {
      handleSeleccionarSesion(sesion);
    }
  }

  var sesionesOrdenadas = orden === ORDEN_ALFABETICO ? sesiones.sort(function (a, b) {
    return a.nombre < b.nombre ? -1 : 1;
  }) : sesiones.sort(function (a, b) {
    return a.fecha < b.fecha ? -1 : 1;
  });

  if (nuevoDisenoSesiones === "version2") {
    return React.createElement('div', {
      className: 'selectorSesion'
    }, React.createElement('div', {
      className: 'edicionSesiones'
    }, React.createElement('span', {
      htmlFor: 'nuevoNombreSesion',
      className: 'etiquetaSesion'
    }, textoNuevaSesion)), React.createElement('div', {
      className: 'nuevaSesion'
    }, React.createElement('div', {
      className: 'nuevoNombreSesion'
    }, React.createElement('input', {
      ref: nuevaSesionRef,
      type: 'text',
      id: 'nuevoNombreSesion',
      name: 'nuevoNombreSesion'
    })), React.createElement('div', {
      className: 'botonEdicionSesiones',
      onClick: handleNuevaSesion
    }, textoAceptar)), React.createElement('div', {
      className: 'edicionSesiones'
    }, React.createElement('span', {
      className: 'etiquetaSesion'
    }, textoSesiones), React.createElement('select', {
      className: 'ordenSesiones',
      value: orden,
      onChange: handleOrdenar
    }, React.createElement('option', {
      value: ORDEN_POR_FECHA
    }, textoOrdenarPorFecha), React.createElement('option', {
      value: ORDEN_ALFABETICO
    }, textoOrdenarAlfabeticamente))), React.createElement('div', {
      className: 'listaSesiones'
    }, React.createElement('ul', null, sesionesOrdenadas.map(function (sesion) {
      return React.createElement('li', {
        key: 'sesion-' + orden + '-' + sesion.id,
        className: '' + (idSesionSeleccionada === sesion.id ? 'activa' : sesion.id === sesionSeleccionada.id ? 'activa' : ''),
        onClick: function onClick() {
          return handleSeleccionarSesion(sesion);
        }
      }, sesion.nombre);
    }))));
  } else {
    // versión 1 (~flash)
    return React.createElement('div', {
      className: 'selectorSesion'
    }, React.createElement('span', {
      className: 'etiquetaSesion'
    }, textoSesiones), React.createElement('select', {
      className: 'ordenSesiones',
      value: orden,
      onChange: handleOrdenar
    }, React.createElement('option', {
      value: ORDEN_POR_FECHA
    }, textoOrdenarPorFecha), React.createElement('option', {
      value: ORDEN_ALFABETICO
    }, textoOrdenarAlfabeticamente)), React.createElement('div', {
      className: 'listaSesiones'
    }, React.createElement('ul', null, sesionesOrdenadas.map(function (sesion) {
      return React.createElement('li', {
        key: 'sesion-' + orden + '-' + sesion.id,
        className: '' + (idSesionSeleccionada === sesion.id ? 'seleccionada' : sesion.id === sesionSeleccionada.id ? 'seleccionada' : ''),
        onClick: function onClick() {
          return handleSeleccionarSesion(sesion);
        }
      }, sesion.nombre);
    }))));
  }
}

SelectorSesion.propTypes = process.env.NODE_ENV !== "production" ? {
  idUltimaSesionActiva: t.string.isRequired,
  sesiones: t.arrayOf(t.shape({
    id: t.string.isRequired,
    nombre: t.string.isRequired,
    fecha: t.number
  })),
  textoSesiones: t.string.isRequired,
  textoNuevaSesion: t.string.isRequired,
  textoAceptar: t.string.isRequired,
  textoOrdenarPorFecha: t.string.isRequired,
  textoOrdenarAlfabeticamente: t.string.isRequired,
  onSeleccionarSesion: t.func,
  onNuevaSesion: t.func,
  sesionSeleccionada: t.string,
  nuevoDisenoSesiones: t.string
} : {};
export default SelectorSesion;